import './App.css';
import React from 'react';
import * as Icon from 'react-feather';
import Microlink from '@microlink/react';
// import LazyLoad from 'react-lazyload'; // Optional for performance

const newsLinks = [
  "https://www.news18.com/opinion/opinion-work-from-home-is-no-shield-against-toxic-air-unless-indoor-discipline-is-followed-ws-l-9807470.html",
  "https://www.firstpost.com/opinion/world-plastic-crisis-awareness-and-circular-economy-can-save-the-day-13879800.html",
  "https://www.news18.com/opinion/opinion-cloud-seeding-between-hope-humility-and-the-limits-of-control-ws-kl-9677008.html",
  "https://timesofindia.indiatimes.com/blogs/voices/climate-negotiations-a-process-that-fails-yet-cannot-be-abandoned/",
  "https://timesofindia.indiatimes.com/blogs/voices/oceans-of-inequity-how-technology-may-divide-the-last-commons/",
  "https://indianexpress.com/article/opinion/columns/cleaning-delhis-air-requires-a-delhi-specific-plan-10427736/",
  "https://www.moneycontrol.com/news/opinion/wake-up-india-ai-colonialism-is-not-a-myth-12958134.html",
  "https://www.linkedin.com/posts/arun-kumar-mehta-182175b6_86000-projects-taken-up-on-single-tender-activity-7321058160985657344-vC54/",
  "https://www.linkedin.com/posts/arun-kumar-mehta-182175b6_baramulla-jammu-kashmir-three-decades-activity-7333465226681454593-HavY/",
  "https://www.news18.com/india/no-scope-of-corruption-in-j-k-now-as-all-services-made-online-chief-secretary-8563185.html",
  "https://www.kashmirnewsobserver.com/top-stories/tribunal-throws-out-ashok-parmar-s-petition-against-lg-senior-bureaucrats-kno-186976",
  "https://www.linkedin.com/posts/arun-kumar-mehta-182175b6_86000-projects-taken-up-on-single-tender-activity-7321058160985657344-vC54/",
  "https://www.tribuneindia.com/news/j-k/house-panel-formed-to-investigate-irregularities-in-jal-jeevan-mission/",
  "https://www.hindustantimes.com/cities/chandigarh-news/jk-administration-denies-any-scam-in-jal-jeevan-mission-implementation-101694631170282.html",
  "https://timesofindia.indiatimes.com/india/arun-kumar-mehta-is-jks-new-chief-secretary/articleshow/83014498.cms",
  "https://www.earlytimes.in/newsdet.aspx?q=316939",
  "https://www.newindianexpress.com/nation/2023/Nov/01/srinagar-diary-after-dgp-jk-to-get-new-chief-secretary-2628913.html",
  "https://www.news18.com/news/india/jk-govt-appoints-ias-officer-arun-kumar-mehta-as-new-chief-secretary-3787574.html",
  "https://www.knskashmir.com/jandk-govt-officially-appoints-arun-kumar-mehta-as-chief-secretary-80395",
  "https://thetypewriter.in/dr-arun-kumar-mehta-is-new-chief-secretary-of-jk-vows-to-work-for-the-welfare-of-people/"
];

const moeLinks = [
  "https://timesofindia.indiatimes.com/blogs/voices/clean-air-indias-missing-infrastructure/",
  "https://www.news18.com/opinion/opinion-delhis-air-the-myths-that-keep-choking-us-ws-kl-9665926.html",
  
  "https://media.un.org/photo/en/asset/oun7/oun758620?utm_source=perplexity",
  "https://www.hindustantimes.com/india-news/world-leaders-gift-ailing-planet-unambitious-draft-on-climate-change/story-UHWG0tZt7mrucfGnuMTTcL.html?utm_source=perplexity",
  "https://www.indiatoday.in/education-today/gk-current-affairs/story/cop24-7-points-india-paris-climate-agreement-principles-1408519-2018-12-13?utm_source=perplexity",
  "https://www.tribuneindia.com/2014/20140603/j&k.htm",
  "https://m.economictimes.com/news/politics-and-nation/81-per-cent-power-supply-restored-in-kashmir-jammu-and-kashmir-government/articleshow/43236925.cms?utm_source=perplexity",
  "https://share.google/xrFfgKiMxwnSuTRQh",
"https://www.dailyexcelsior.com/prime-minister-narendra-modi-conferring-the-award-for-excellence-in-public-administration-to-jk-chief-secretary-dr-arun-kumar-mehta-on-the-occasion-of-the-16th-civil-services-day-celebrations-at-vigy/"  
];

const youtubeLinks = [
  "https://www.youtube.com/embed/9JfaalZ3VNw?si=QM_GByQKN9-puABf",
  "https://www.youtube.com/embed/G863MJGsIO4?si=bPyTprJZ-K9KzCBk",
  "https://www.youtube.com/embed/CzgXsn_siPM?si=MYxTElRd9CVYxfHh",
  "https://www.youtube.com/embed/dXtFOLokiSY?si=iMMF8LStcr-QaPgq",
  "https://www.youtube.com/embed/Qu7VK4Q3m8Q?si=ydfO2U0P-8JqiUeR",
  "https://www.youtube.com/embed/SAEt0QJPMb4?si=pb4Oe7grOb7bMfpR",
  "https://www.youtube.com/embed/AsFOVM3AQWk?si=AvYs2wzCtqW-dvfU",
  "https://www.youtube.com/embed/Ypdtr9Qb25A?si=BQocpyAdhjnaflx3",
  "https://www.youtube.com/embed/HsPOErfbQqk?si=QD0-yRtV_zZ5KglC",
  "https://www.youtube.com/embed/8S2NThl5fLs?si=knzc7Ljq_t-tga1f",
  "https://www.youtube.com/embed/W583EdIlUIE?si=FYk9r6DqJDhdai6u",
  "https://www.youtube.com/embed/spStC3N75RU?si=67tmTAchNASiJUIW",
  "https://www.youtube.com/embed/zdM1fxNDC6I?si=0JbjQcgoK6W0f08C",
  "https://www.youtube.com/embed/VPXsOCbds98?si=SewJK8CQsTdgJSWv",
  "https://www.youtube.com/embed/LOvgLP6B-zM?si=WUFLPu7pGD7KHKeU",
  "https://www.youtube.com/embed/esC936LixJc?si=pGB9C7BVSs_4kwbD",
  "https://www.youtube.com/embed/7-6LTaV6K1I?si=KGx0cIpoK1an0VMw",
  "https://www.youtube.com/embed/smXEQq4X5_U?si=fhTSlfB3o9eZ_ZPM",
  "https://www.youtube.com/embed/usqdo0LQaiA?si=KWr_hcJ3MhS0wo48",
  "https://www.youtube.com/embed/Ph3QnQ914sA?si=TeiZhWAKTavq28ai",
  "https://www.youtube.com/embed/Scnj3EwFn_Y?si=rK1whqQ7z6z1ldmb",
  "https://www.youtube.com/embed/MeFdZkl9Qxg?si=qX-rDBfFedwJK_nc",
  "https://www.youtube.com/embed/mgvZGil7BgQ?si=D1NvklTYDYVXK0xY",
  "https://www.youtube.com/embed/WVhYmptDA-4?si=SRQGzIhso2Twrfew",
  "https://www.youtube.com/embed/fmCTTEymj9w?si=8QIRa1bQZ32A00Dt",
  "https://www.youtube.com/embed/g3yc58TwKfs?si=-s6Eou5wRPd2Ga3a",
  "https://www.youtube.com/embed/tQvVoZ97LPI?si=TJYw3yaMma0vzlt0",
  "https://www.youtube.com/embed/SjVbKsZ8BWY?si=ZjrWiYwjCaJQaL8l",
  "https://www.youtube.com/embed/My8nkck4FG4?si=Ga6-oEw2PM8QLKRq"
];

function Tweet() {
  return (
    <div className="App">
      <h1>PUBLICATIONS & MEDIA</h1>
      <main className="App-main">
        <div className="Column">
          {newsLinks.map((url, index) => (
            <div key={index}>
              <Microlink url={url} />
              <br /><br />
            </div>
          ))}
        </div>

        <div className="Column">
          {moeLinks.map((url, index) => (
            <div key={index}>
              <Microlink url={url} />
              <br /><br />
            </div>
          ))}
        </div>

        <div className="Column">
          {youtubeLinks.map((link, index) => (
            // <LazyLoad key={index} height={215} offset={100}>  // Optional
              <iframe
                key={index}
                src={link}
                style={{ border: 'none', marginBottom: '20px', marginRight:'20px' }}
                title={`YouTube video ${index + 1}`}
                allowFullScreen
              ></iframe>
            // </LazyLoad>
          ))}
        </div>
      </main>

      <footer className="App-footer">
        <a
          className="App-link"
          href="https://www.linkedin.com/in/arun-kumar-mehta-182175b6/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon.Linkedin />
        </a>
     </footer>
    </div>
  );
}

export default Tweet;
